import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
    cashierTab: {
        background: theme.palette.primary.main,
        color: "#fff"
    }
}));
